// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Breadcrumbs_wrap__2yJCP","linkWrap":"Breadcrumbs_linkWrap__3Qiyc","link":"Breadcrumbs_link__3Pgjg"};